import { render, staticRenderFns } from "./age.vue?vue&type=template&id=e18152de&lang=pug&"
import script from "./age.vue?vue&type=script&lang=js&"
export * from "./age.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports